import SignInForm from './SignInForm';

const Authentication = () => <SignInForm />;

export default Authentication;
